import React, { useEffect, useCallback } from 'react';
import './Navigation.scss';

import { useDispatch, useSelector } from 'react-redux';

import tmx from './tmx-brand-mark.svg';

import { useSearchParams, useNavigate } from 'react-router-dom';

import { callSignIn, callSignOut } from '../../Apis/actions/signin-actions';

const Navigation = () => {
  const { isLoggedin } = useSelector((state) => state.signInReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const formattedSubject = 'Request for a contact not found in the Search Engine';
  const mailToLink =
    'mailto:bot-user-sending-us-m-aaaaqcwxmgi4evf6kftva3jjou@tmxnews.slack.com?subject=' +
    encodeURIComponent(formattedSubject);

  const bookDemoLink = 'https://calendly.com/mztmx/demo-tmx-search?back=1&month=2025-05';

  // url pattern = ?email=xyx&domainID=null&isNewsroom=false
  const isEmailPresent =
    searchParams.get('email') || JSON.parse(localStorage.getItem('userData'))?.email;
  const isTokenPresent =
    searchParams.get('token') || JSON.parse(localStorage.getItem('userData'))?.token;

  const isAdmin = JSON.parse(localStorage.getItem('userData'))?.isAdmin;

  useEffect(() => {
    if (isEmailPresent !== '' && isTokenPresent !== '') {
      dispatch(callSignIn(isEmailPresent, isTokenPresent));
    }
  }, [dispatch, isTokenPresent, isEmailPresent]);

  useEffect(() => {
    if (
      (window.location.pathname === '/personsearch' ||
        window.location.pathname === '/contact-detail') &&
      isLoggedin
    ) {
      // navigate(window.location.pathname);
    } else if (isLoggedin && isAdmin) {
      navigate('/analytics');
    } else if (isLoggedin && !isAdmin) {
      navigate('/notadminpage');
    } else if (isLoggedin && !searchParams.get('email') && window.location.pathname !== '/chat') {
      // navigate('/chat');
    } else if (
      !isLoggedin &&
      !JSON.parse(localStorage.getItem('userData')) &&
      !searchParams.get('email')
    ) {
      navigate('/signup');
    }
  }, [isLoggedin, navigate, searchParams, isAdmin]);

  const handleClick = useCallback(() => {
    window.localStorage.clear();
    dispatch(callSignOut());
    navigate('/signup');
  }, [navigate, dispatch]);

  const handlePeopleFinderLink = () => {
    navigate('/personsearch');
  };

  const handleGoHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <>
      <nav className="tmx-navigation">
        <div className="tmx-navigation__tempImageContainer">
          <div onClick={handleGoHome} className="tmx-navigation__logoContainer">
            <img src={tmx} className="tmx-navigation__logoImage" alt="logo" />
            tmxanalytics
          </div>
          <div onClick={handleGoHome} className="tmx-navigation__mobieLogoContainer">
            <img src={tmx} className="tmx-navigation__logoImageMobile" alt="logo" />
          </div>
        </div>
        {/* <button className="tmx-navigation__button">Experiance our AI Assistant</button> */}
        {isLoggedin && (
          <div className="tmx-navigation__buttonContainer">
            <a
              href={bookDemoLink}
              target="_blank"
              rel="noreferrer"
              className="tmx-navigation__button tmx-navigation__button--demo">
              Pro Tips
            </a>
            <a
              href={handlePeopleFinderLink}
              onClick={handlePeopleFinderLink}
              target="_blank"
              rel="noreferrer"
              className="tmx-navigation__button tmx-navigation__button--mailTo">
              Regular Person
            </a>
            <a
              href={mailToLink}
              target="_blank"
              rel="noreferrer"
              className="tmx-navigation__button tmx-navigation__button--mailTo">
              Bad Result
            </a>

            <button onClick={handleClick} className="tmx-navigation__button">
              Sign Out
            </button>
          </div>
        )}
      </nav>
    </>
  );
};

Navigation.propTypes = {};

export default Navigation;
